import styled from 'styled-components';

export const OrderDetailsBox = styled.div`
  background: #f7f7f8;
  padding: 0.75rem;
`;

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  min-height: 20px;
  margin-right: 2rem;
  margin-top: -1.25rem;
`;

export const PaginationContainer = styled.div`
  display: inline-flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border: 1px solid #dadada;
  border-radius: 25px;
  box-shadow: 1px 1px 5px 0 #d5d5d5;
  height: 48px;
  margin: 8px 0 28px !important;
  padding: 1rem;
`;

export const PageButtons = styled.button`
  background-color: #fff !important;
  width: 48px;
  height: 32px;
  border: 2px solid #fff;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  align-content: center;
  margin: 8px 4px 8px 0;
  cursor: default;
  font-weight: 500;

  &: hover {
    border-color: #4b286d;
  }
  &:active {
    outline: none;
  }
  &:focus {
    outline: none;
  }
`;

export const ActivePage = styled.button`
  background-color: #4b286d !important;
  color: #fff;
  width: 48px;
  height: 32px;
  border: 2px solid #fff;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  align-content: center;
  margin: 8px 4px 8px 0;
  cursor: default;
  font-weight: 500;

  &:active {
    outline: none;
  }
  &:focus {
    outline: none;
  }
`;

export const NaviagationButtonText = styled.p`
  font-size: 24px;
  margin-top: -7px;
`;

export const NaviagationButtons = styled.button`
  background-color: #fff;
  width: 48px;
  height: 32px;
  border: 2px solid #fff;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  align-content: center;
  cursor: default;
  color: #4b286d;
  font-weight: 500;
  align-item: center;

  &: hover {
    background-color: #f7f7f8 !important;
  }
  &:active {
    outline: none;
  }
  &:focus {
    outline: none;
  }
`;

export const customStyles = `
  overflow: scroll;
  max-height: 100% !important;
  height:100%;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: white;`;

export const DefectSummaryRow = styled.div`
  border: 1px solid #eaeaea;
  border-radius: 5px;
  margin-top: 0.5rem;
`;

export const DefectSummaryFirstCol = styled.div`
  color: #ababab;
  width: 250px;
  padding-right: 20px;
  padding: 10px;
  float: left;
  background: #f7f7f8;
`;

export const DefectSummarySecondCol = styled.div`
  padding-right: 20px;
  padding: 10px;
  float: left;
  word-break: break-word;
`;

export const DefectAttachmentRow = styled.div`
  border: 1px solid #eaeaea;
  border-radius: 5px;
  margin-top: 0.5rem;
  margin-bottom: 1rem !important;
  height: 40px;
  padding: 10px;
`;

export const Filename = styled.div`
  align-items: start;
`;

export const FileDownload = styled.div`
  align-items: end;
`;

export const Container = styled.div`
  margin-bottom: 4rem;
`;

export const SummaryWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;
